<template>
	<div class="fast-words">
		<div class="fast-words__tools">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-input placeholder="搜索关键词" v-model="listQuery.searchVal" clearable  prefix-icon="el-icon-search" @keydown.native="toEnter">
					</el-input>
				</el-col>
				<el-col :span="12">
					 <el-button class="search-btn" @click="toSearch" size="small">查 询</el-button>
					<el-button class="search-btn" icon="el-icon-download" size="small" @click="toDownload">下载导入模板</el-button>
					<el-upload
					 	style="display: inline-block;margin-left: 10px;"
					 	action=""
					 	:http-request="toImport"
					 	:show-file-list="false"
					 	 accept=".xlsx">
					 	 <el-button class="search-btn" icon="el-icon-upload2" size="small">覆盖导入</el-button>
					 </el-upload>
				</el-col>
			</el-row>

		</div>
		<div class="fast-words__tree">
			<TreeBox :hasOperate="true" :searchVal="listQuery.searchVal" ref="fastWords" :isRefresh="isRefresh"></TreeBox>
		</div>
	</div>
</template>

<script>
	import TreeBox from './tree.vue'
	import {download} from '@/utils/functions.js'
	export default {
		components:{
			TreeBox
		},
		data(){
			return {
				listQuery:{
					searchVal:'',
				},
				isRefresh:false,
				fileUrl:process.env.VUE_APP_BASE_API
			}
		},
		methods:{
			toEnter(event){
				if(event.keyCode == 13 && event.shiftKey == false ) {
					event.preventDefault()
					this.toSearch();
				}
			},
			toSearch(){
				this.$refs.fastWords.toSearch(this.listQuery.searchVal)
			},
			toDownload(){
				this.$api.downloadSystemFastWordsModel().then(res => {
					if(res.errcode == 0) {
						download(`${this.fileUrl}/ocs-kdb${res.data}`)
					}
				})
			},
			toImport(params){
				if(this.beforeUpload(params.file)) {
					const formData = new FormData();
					 formData.append('file', params.file)
					this.$api.importSystemFastWordsFile(this.$store.state.user.brandId,formData).then(res => {
						if(res.errcode == 0) {
							this.isRefresh = true
							this.$message.success('导入成功');
						}
					})
				}
			},
			beforeUpload(file){
				const isTrue = file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				const isLimitSize = file.size / 1024 / 1024 < 20;
				if(!isTrue) {
					this.$message.error(`导入只能是xlsx格式`)
					return false
				}
				if(!isLimitSize) {
					this.$message.error("导入文件大小不能超过20M")
					return false
				}
				return true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.fast-words {
		.search-btn {
			color: #337EFF;
			border: 1px solid #337EFF;
		}
		&__tree {
			margin-top: 40px;
			height: 700px;
		}
	}
</style>
